import './vehicle.comments';
import './vehicle.detail';
import './vehicle.gallery';
import './vehicle.parts-gallery';